import styled from 'styled-components'

export default styled.div`
  border: 1.5px solid #333333;
  width: 110%;
  margin: 16px 0px;
`
